// Plain data model for a plan/project row shown in app-home lists.
// Deliberately free of AngularJS / moment / Sugar imports so it can be
// consumed by pure modules (e.g. the plan-list cache) and unit-tested in
// the Node Jasmine harness without pulling in Angular registration.
export class SimpleProject {

    constructor(public id: string) {
    }

    name: string;
    description: string;
    lastEditedUnix: number;
    lastEdited: string;
    lastEditedUserEmail: string;
    isShared: boolean;
    accessLevel: string;
    canEdit: boolean;
    isOwnedByMe: boolean;
    projectType: string;
    isDeleted: boolean;

    thumbnailUrl: string;
    planStart: string;
    planEnd: string;
    // So lists can sort without reparsing the display strings.
    planStartUnix: number;
    planEndUnix: number;
    workHours: number;
    percentComplete: number;
    subprojectCount: number;
    ownerEmail: string;

    getID(): string {
        return this.id;
    }
}
